export default {
    "": "Trống",
    "kt": "Khởi tạo",
    "inc": "INC",
    "odz": "ODZ",
    "ht": "Hoàn thành",
}
